module.exports = __webpack_public_path__ + "static/media/porin.17a55d82.wav";